import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavMenuService {

  activeTab = new BehaviorSubject<string>("");
  activeInvestTab = new BehaviorSubject<string>("");
  activeTransactTab = new BehaviorSubject<string>("");
  isTransactTabActive= new BehaviorSubject<boolean>(false);

  constructor() { }

  getActiveNavMenuTab() {
    return this.activeTab.asObservable();
  }

  setActiveNavMenuTab(details) {
    this.activeTab.next(details)
  }

  getActiveInvestMode() {
    return this.activeInvestTab.asObservable();
  }

  setActiveInvestMode(details) {
    this.activeInvestTab.next(details)
  }

  getActiveTransactMenuTab() {
    return this.activeTransactTab.asObservable();
  }

  setActiveTransactMenuTab(details) {
    this.activeTransactTab.next(details)
  }

  getIsTransactTabActive() {
    return this.isTransactTabActive.asObservable();
  }

  setIsTransactTabActive(details) {
    this.isTransactTabActive.next(details)
  }


}
